import { AssetPurgedEvent } from '../event/asset-purged.event';
const assetPurgedProjections = {
    [AssetPurgedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            purged: payload.purged,
        };
    },
};
export default assetPurgedProjections;
//# sourceMappingURL=asset-purged.projection.js.map